/* eslint-disable react/no-access-state-in-setstate */
/* eslint-disable react/sort-comp */
/* eslint-disable react/prop-types */
/* eslint-disable react/destructuring-assignment */
import React from 'react';

import QRCode from 'qrcode-react';
import {connect} from 'react-redux';

import * as deviceInfoActions from '@/actions/deviceInfoActions';
import * as loadingActions from '@/actions/loadingActions';
import * as modalActions from '@/actions/modalActions';
import * as setupActions from '@/actions/setupActions';
import {Get, Post} from '@/api/request';
import NoNetworkIcon from '@/assets/icons/NoNetworkIcon.svg';
import ToggleButtonCustom from '@/components/togglebutton/src/ToggleButtonCustom';
import * as APPDATA from '@/constants/pcConstAppData';
import {EventCheckUpdateSystem, EventLicenseService} from '@/constants/pubSubEnum';
import {consoleLog, consoleError} from '@/libs/consoleHelper';
import {newLineHtml} from '@/libs/htmlHelper';
import {gapFixerClass} from '@/libs/styleHelper';
import {eventBusObject} from '@/observers/eventBus';

import './InfoPage.scss';

const UPDATE_MODE = {
  ONLINE: 'ONLINE',
  OFFLINE: 'OFFLINE',
};

const DEVICE_NOT_CONNECTED_TO_NETWORK = 'Device is Not Connected to Network';
@connect((store) => ({
  hardwareList: store.modalStore.hardwareList,
  fontSize: store.setupStore.fontSize,

  deviceSerialNumber: store.deviceInfoStore.deviceSerialNumber,
  firmwareName: store.deviceInfoStore.firmwareName,
  firmwareVersion: store.deviceInfoStore.firmwareVersion,
  softwareName: store.deviceInfoStore.softwareName,
  softwareVersion: store.deviceInfoStore.softwareVersion,
  buildDate: store.deviceInfoStore.buildDate,
  hostName: store.deviceInfoStore.hostName,
  ipAddress: store.deviceInfoStore.ipAddress,
  macAddress: store.deviceInfoStore.macAddress,
  licenseStatus: store.deviceInfoStore.licenseStatus,
  licenseType: store.deviceInfoStore.licenseType,
  licenseModifiedDate: store.deviceInfoStore.licenseModifiedDate,
  licenseExpiredDate: store.deviceInfoStore.licenseExpiredDate,
  clientID: store.deviceInfoStore.clientID,
  licenseActivationMode: store.deviceInfoStore.licenseActivationMode,
  isTrialAvailable: store.deviceInfoStore.isTrialAvailable,
  isRestartLater: store.updateSystemStore.IsRestartLater,
  deviceInfoStore: store.deviceInfoStore,
  downloadBinaryStatus: store.updateSystemStore.StatusDonloadBinaryUpdate,
}))
class InfoPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isDownloadUpdate: false,
      isInstallingUpdate: false,
      softwareUpdateMethod: UPDATE_MODE.ONLINE,
      getUSBCount: 0,
      remoteSession: {
        message: null,
        sessionAction: undefined,
        sessionState: undefined,
      },
      remoteDeviceStatus: {
        id: null,
        status: undefined,
      },
    };

    this._bus = eventBusObject();
    this._getUSBPooling = undefined;
    this._remoteSupportSessionPolling = undefined;
    this._remoteSupportDeviceStatusPolling = undefined;
    this.successGetInfo = this.successGetInfo.bind(this);
    this.successPostStartRemoteSupport = this.successPostStartRemoteSupport.bind(this);
    this.errorPostStartRemoteSupport = this.errorPostStartRemoteSupport.bind(this);
    this.failedPostStartRemoteSupport = this.failedPostStartRemoteSupport.bind(this);
    this.successPostStopRemoteSupport = this.successPostStopRemoteSupport.bind(this);
    this.errorPostStopRemoteSupport = this.errorPostStopRemoteSupport.bind(this);
    this.failedPostStopRemoteSupport = this.failedPostStopRemoteSupport.bind(this);
    this.successGetLicenseInfo = this.successGetLicenseInfo.bind(this);
    this.failedGetLicenseInfo = this.failedGetLicenseInfo.bind(this);
    this.successGetUSBDrive = this.successGetUSBDrive.bind(this);
    this.failedGetUSBDrive = this.failedGetUSBDrive.bind(this);
    this.successGetRemoteSupportSession = this.successGetRemoteSupportSession.bind(this);
    this.errorGetRemoteSupportSession = this.errorGetRemoteSupportSession.bind(this);
    this.successGetRemoteSupportDeviceStatus = this.successGetRemoteSupportDeviceStatus.bind(this);
    this.errorGetRemoteSupportDeviceStatus = this.errorGetRemoteSupportDeviceStatus.bind(this);
  }

  componentDidMount() {
    this.props.dispatch(setupActions.updateActiveMenu(APPDATA.INFO_AND_SUPPORT));
    const backButtonProperties = {
      id: APPDATA.BACK,
      label: '',
      disabled: this.props.licenseStatus !== 'Active' && this.props.licenseType !== 'Instrument',
      onClick: this.backToHomePage,
    };
    const updateButtonProperties = {
      id: APPDATA.UPDATE,
      label: APPDATA.UPDATE,
      disabled:
        this.props.isRestartLater ||
        this.props.downloadBinaryStatus?.Status === APPDATA.DownloadState.DOWNLOADING ||
        this.props.downloadBinaryStatus?.Status === APPDATA.DownloadState.COMPLETE,
      onClick: this.onClick,
    };
    this.setTopMenuProperties(updateButtonProperties, backButtonProperties, APPDATA.INFO_AND_SUPPORT);
    // this._bus.publish(EventLicenseService.LicenseInfoService, {});
    this.getInfo();

    this._updateChecker = setInterval(() => {
      if (this.state.isDownloadUpdate) {
        this.checkDownloadUpdateStatus();
      }
      if (this.state.isInstallingUpdate) {
        this.checkInstallUpdateStatus();
      }
    }, 500);
    setTimeout(() => {
      this.getInfo();
      this.getLicenseInfo();
    }, 5000);
  }

  shouldComponentUpdate(nextProps) {
    if (this.props.deviceInfoStore !== nextProps.deviceInfoStore) return true;
    if (this.props.downloadBinaryStatus !== nextProps.downloadBinaryStatus) return true;
    if (this.props.isRestartLater !== nextProps.isRestartLater) return true;
    return false;
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.isRestartLater !== prevProps.isRestartLater ||
      this.props.licenseStatus !== prevProps.licenseStatus ||
      this.props.licenseType !== prevProps.licenseType ||
      this.props.downloadBinaryStatus !== prevProps.downloadBinaryStatus
    ) {
      const backButtonProperties = {
        id: APPDATA.BACK,
        label: '',
        disabled: this.props.licenseType !== 'Instrument' && this.props.licenseStatus !== 'Active',
        onClick: this.backToHomePage,
      };
      const updateButtonProperties = {
        id: APPDATA.UPDATE,
        label: APPDATA.UPDATE,
        disabled:
          this.props.isRestartLater ||
          this.props.downloadBinaryStatus?.Status === APPDATA.DownloadState.DOWNLOADING ||
          this.props.downloadBinaryStatus?.Status === APPDATA.DownloadState.COMPLETE,
        onClick: this.onClick,
      };
      this.setTopMenuProperties(updateButtonProperties, backButtonProperties, APPDATA.INFO_AND_SUPPORT);
    }
  }

  getLicenseInfo = () => {
    const param = {};
    const passingValue = {};
    Get(
      APPDATA.API.GET_LICENSE_INFO,
      param,
      this.successGetLicenseInfo,
      passingValue,
      () => {},
      this.failedGetLicenseInfo,
    );
  };

  successGetLicenseInfo = (response) => {
    if (response.data !== undefined) {
      this.props.dispatch(deviceInfoActions.updateLicenseInfo(response.data));
      // const isDemo = !(
      //   (response.data.LicenseStatus === APPDATA.FIELD_NAME.LICENSE.STATUS.ACTIVE &&
      //     response.data.LicenseType === APPDATA.FIELD_NAME.LICENSE.TYPE.TEMPORARY) ||
      //   response.data.LicenseType === APPDATA.FIELD_NAME.LICENSE.TYPE.PERMANENT
      // );
      // if (this._ismounted) {
      //   this.setState({
      //     isDemoMode: isDemo,
      //   });
      // }
    }
  };

  failedGetLicenseInfo = () => {
    this.props.dispatch(
      setupActions.showAlert({
        alertShow: true,
        alertText: APPDATA.MESSAGES.LICENSE.ALLERT.FAILED_INFO,
        alertStyle: APPDATA.ENUM.ALERT_TYPE.ALERT_INFO,
      }),
    );
  };

  // TODO : refactor using hook
  setTopMenuProperties = (topButtonProperties, backButtonProperties, titleMenuProperties) => {
    this.props.dispatch(
      setupActions.setTopMenuProperties({
        topButtonProperties:
          topButtonProperties === undefined
            ? undefined
            : {
                id: topButtonProperties.id,
                label: topButtonProperties.label,
                disabled: topButtonProperties.disabled,
                onClick: topButtonProperties.onClick,
              },
        backButtonProperties:
          backButtonProperties === undefined
            ? undefined
            : {
                id: backButtonProperties.id,
                label: backButtonProperties.label,
                disabled: backButtonProperties.disabled,
                onClick: backButtonProperties.onClick,
              },
        titleMenuProperties,
      }),
    );
    this.props.dispatch(setupActions.topButtonTertiaryProperties(undefined));
  };

  // TODO : refactor using hook
  // eslint-disable-next-line class-methods-use-this
  backToHomePage = () => {
    window.location.href = APPDATA.HOME_SCREEN_ADDRESS;
  };

  // ---------------------------------------- OFFLINE MODE ----------------------------
  // eslint-disable-next-line class-methods-use-this
  goToUSBFileList() {
    window.location.href = APPDATA.USB_FILE_LIST_ADDRESS;
  }

  componentWillUnmount() {
    this.props.dispatch(loadingActions.showLoading(false));
    if (typeof this._updateChecker !== 'undefined') {
      clearInterval(this._updateChecker);
      this._updateChecker = undefined;
    }
    if (typeof this._getUSBPooling !== 'undefined') {
      clearInterval(this._getUSBPooling);
      this._getUSBPooling = undefined;
    }
    if (typeof this._remoteSupportSessionPolling !== 'undefined') {
      clearInterval(this._remoteSupportSessionPolling);
      this._remoteSupportSessionPolling = undefined;
    }
    if (typeof this._remoteSupportDeviceStatusPolling !== 'undefined') {
      clearInterval(this._remoteSupportDeviceStatusPolling);
      this._remoteSupportDeviceStatusPolling = undefined;
    }
  }

  successGetUSBDrive(response) {
    if (this._stopProcess) return;

    // remove /rootfs and /boot partitions
    const regex = /(rootfs|boot)(-[0-9]+)?$/;
    const filteredDetails = response.data.details.filter(({Path}) => !regex.test(Path));

    // go to next step
    if (response.data.details.length > 0) {
      this._stopProcess = true;
      consoleLog('successGetUSBDrive', response);
      consoleLog('USB IS READY, SHOW LIST NOW');

      if (typeof this._getUSBPooling !== 'undefined') {
        clearInterval(this._getUSBPooling);
        this._getUSBPooling = undefined;
      }
      // TODO : make function to parse USB properties. NOT USE REDUX !!
      this.props.dispatch(setupActions.usbOpenFor(APPDATA.USB_OPEN_FOR.IMPORT_UPDATE));
      this.props.dispatch(setupActions.usbProperties(filteredDetails));
      this.props.dispatch(loadingActions.showLoading(false));
      this.goToUSBFileList();
    } else {
      this._stopProcess = false;
      // consoleLog("USB NOT READY, MOUNT NOW, AND GET FILE LIST", this._stopProcess);
      if (!this._stopProcess) this.checkAvailableFlash();
      // mount usb flash
    }
  }

  failedGetUSBDrive(error) {
    // will show error from request
    // force close
    // usb not found
    consoleError('Error : Failed get USB Drive', error);
    this.props.dispatch(
      setupActions.showAlert({
        alertShow: true,
        alertText: APPDATA.MESSAGES.EXPORT_IMPORT.FAILED_GET_FLASH_DRIVE, // response.message,
        alertStyle: APPDATA.ENUM.ALERT_TYPE.ALERT_DANGER,
      }),
    );
    this.props.dispatch(loadingActions.showLoading(false));
  }

  checkAvailableFlash() {
    setTimeout(() => {
      const params = {
        params: {
          partition: APPDATA.CONFIGURATION.USB_FLASH.PARTITION_USB_FLASH,
        },
      };
      const passingVariabel = {};
      consoleLog(params);
      Get(APPDATA.API.GET_USB_DRIVE, params, this.successGetUSBDrive, passingVariabel, this.failedGetUSBDrive);
    }, 1000);
  }
  // -------------------------------------- END OFFLINE MODE --------------------------

  // tapLoadingScreen = (text, question, onClickButton) => {
  //   const popUpButton = [
  //     {
  //       id: APPDATA.CONTINUE,
  //       isPrimaryButton: true,
  //       onClick: onClickButton,
  //       label: APPDATA.CONTINUE,
  //     },
  //     {
  //       id: APPDATA.CANCEL,
  //       isPrimaryButton: false,
  //       onClick: onClickButton,
  //       label: APPDATA.CANCEL,
  //     },
  //   ];
  //   this.props.dispatch(
  //     modalActions.showPopUp({
  //       popUpTitle: APPDATA.UPDATE_SOFTWARE,
  //       popUpText: text,
  //       popUpQuestion: question,
  //       popUpButton,
  //     }),
  //   );
  // };

  // tapScreenDownloadCheckVersion = () => {
  //   const text = APPDATA.MESSAGES.SOFTWARE_UPDATE.STOP_DOWNLOAD_VERSION;
  //   const question = APPDATA.MESSAGES.SOFTWARE_UPDATE.STOP_DOWNLOAD_QUESTION;
  //   const buttonEvent = this.onClickTapDownloadVersion;
  //   this.tapLoadingScreen(text, question, buttonEvent);
  // };

  // onClickTapDownloadVersion = (e) => {
  //   switch (e.currentTarget.id) {
  //     case APPDATA.CANCEL:
  //       this.props.dispatch(loadingActions.showLoading(false));
  //       break;
  //     case APPDATA.CONTINUE:
  //       break;
  //     default:
  //       break;
  //   }
  //   this.props.dispatch(modalActions.hidePopUp());
  // };
  //---------------------------------------------------------------------------------

  updateMode() {
    const modeUpdate = [
      {
        label: UPDATE_MODE.ONLINE,
        value: 1,
        customButtonSize: true,
      },
      {
        label: UPDATE_MODE.OFFLINE,
        value: 2,
        customButtonSize: true,
      },
    ];
    const popUpButton = [
      {
        id: APPDATA.CONTINUE,
        isPrimaryButton: true,
        onClick: this.onClickSelectMode,
        label: APPDATA.CONTINUE,
        // disabled: !isTubeDetached,
      },
      {
        id: APPDATA.CANCEL,
        isPrimaryButton: false,
        onClick: this.onClickSelectMode,
        label: APPDATA.CANCEL,
      },
    ];
    const modeValue = this.state.softwareUpdateMethod === UPDATE_MODE.ONLINE ? 1 : 2;

    this.props.dispatch(
      modalActions.showPopUp({
        popUpTitle: APPDATA.UPDATE_SOFTWARE,
        popUpText: (
          <div>
            <div className="">
              {APPDATA.MESSAGES.UPDATE.UPDATE_TYPE}
              <br />
              <br />
            </div>
            <div className="row ">
              <div className="col-md-3" />
              <div className="col-md-6">
                <ToggleButtonCustom
                  buttonProp={modeUpdate}
                  defaultValue={modeValue}
                  value={modeValue}
                  onClick={this.onClickUpdateMode.bind(this)}
                />
              </div>
              <div className="col-md-3" />
            </div>
            <br />
            {/* <div>
                            <CheckBox
                                id="tube_detached_checkbox"
                                onChange={this.toggleCheckboxValue}
                                value={isTubeDetached}
                                defaultChecked={isTubeDetached}
                                text={APPDATA.MESSAGES.UPDATE.DETACHED_TUBE} //v
                            />
                        </div> */}
          </div>
        ),
        popUpButton,
      }),
    );
  }

  onClickSelectMode = (e) => {
    const {softwareUpdateMethod} = this.state;

    switch (e.currentTarget.id) {
      case APPDATA.CONTINUE: {
        switch (softwareUpdateMethod) {
          case UPDATE_MODE.ONLINE:
            this.checkUpdateVersion();
            break;
          case UPDATE_MODE.OFFLINE:
            this._stopProcess = false;
            this.setState(
              {
                getUSBCount: 0,
              },
              () => {
                // consoleLog("getUSBCount", this.state.getUSBCount);
              },
            );

            this._getUSBPooling = setInterval(() => {
              const getUSBCountTemp = this.state.getUSBCount + 1;
              this.setState(
                {
                  getUSBCount: getUSBCountTemp,
                },
                () => {
                  if (
                    this.state.getUSBCount > APPDATA.CONFIGURATION.USB_FLASH.CEK_USB_TIME_OUT &&
                    this._stopProcess === false
                  ) {
                    this._stopProcess = true;
                    this.props.dispatch(loadingActions.showLoading(false));
                    this.props.dispatch(
                      setupActions.showAlert({
                        alertShow: true,
                        alertText: APPDATA.MESSAGES.EXPORT_IMPORT.FLASH_DRIVE_NOT_FOUND, // response.message,
                        alertStyle: APPDATA.ENUM.ALERT_TYPE.ALERT_DANGER,
                      }),
                    );
                    if (typeof this._getUSBPooling !== 'undefined') {
                      clearInterval(this._getUSBPooling);
                      this._getUSBPooling = undefined;
                    }
                  }
                  // consoleLog("getUSBCount", this.state.getUSBCount);
                },
              );
            }, 1000);
            this.props.dispatch(
              loadingActions.updateLoading({
                showLoading: true,
                loadingText: APPDATA.MESSAGES.SOFTWARE_UPDATE.CHEKING_USB_DRIVE,
                loadingClickEvent: undefined,
                loadingButton1: {
                  label: APPDATA.CLOSE,
                  onClick: () => {
                    this.props.dispatch(loadingActions.showLoading(false));
                    this._stopProcess = true;
                  },
                },
              }),
            );

            this.checkAvailableFlash();
            break;
          default:
            break;
        }
        break;
      }
      case APPDATA.CANCEL:
        break;
      default:
        break;
    }
    this.props.dispatch(modalActions.hidePopUp());
  };

  onClickUpdateMode(e) {
    this.setState({
      softwareUpdateMethod: e.currentTarget.id,
    });
  }

  checkUpdateVersion() {
    // removeSessionStorage(APPDATA.SESSION_STORAGE_KEY.UPDATE_TYPE_SYSTEM);
    this.props.dispatch(
      loadingActions.updateLoading({
        showLoading: true,
        loadingText: APPDATA.MESSAGES.SOFTWARE_UPDATE.CHECK_INTERNET_CONNECTION,

        // note: this cancelation callback for this loading didn't have a requirement
        // loadingClickEvent: this.tapScreenDownloadCheckVersion,
      }),
    );

    this._bus.publish(EventCheckUpdateSystem.CheckingVersionUpdate, {value: APPDATA.INFO_AND_SUPPORT_ADDRESS});
  }

  // onClickNoUpdate = () => {
  //   this.props.dispatch(modalActions.hidePopUp());
  // };

  // toggleCheckboxValue = (e) => {
  //   const isTubeDetached = e.currentTarget.checked;
  //   this.updateMode(isTubeDetached);
  // };

  // checkUpdateAvailable = (data) => {
  //   if (data[APPDATA.KEY.IsUpdateAvailable] === 'true') {
  //     return true;
  //   }
  //   return false;
  // };

  /*
   * v1 === v2 return 0
   * v1 < v2 return -1
   * v1 > v2 return 1
   * v1/v2 not string return false
   */
  // // eslint-disable-next-line class-methods-use-this
  // compareVersion(v1, v2) {
  //   if (typeof v1 !== 'string') return false;
  //   if (typeof v2 !== 'string') return false;
  //   // eslint-disable-next-line no-param-reassign
  //   v1 = v1.split('.');
  //   // eslint-disable-next-line no-param-reassign
  //   v2 = v2.split('.');
  //   const k = Math.min(v1.length, v2.length);
  //   for (let i = 0; i < k; ++i) {
  //     v1[i] = parseInt(v1[i], 10);
  //     v2[i] = parseInt(v2[i], 10);
  //     if (v1[i] > v2[i]) return 1;
  //     if (v1[i] < v2[i]) return -1;
  //   }
  //   // eslint-disable-next-line no-nested-ternary
  //   return v1.length === v2.length ? 0 : v1.length < v2.length ? -1 : 1;
  // }

  // IsNeedUpdate(v1, v2) {
  //   // -1,0,1,false
  //   const versionUpdate = this.compareVersion(v1, v2);
  //   if (versionUpdate < 0 || versionUpdate === false) return false;
  //   return true;
  // }

  onClick = (e) => {
    consoleLog(`${e.currentTarget.id} button clicked`);
    switch (e.currentTarget.id) {
      case APPDATA.UPDATE: {
        // this.checkUpdateVersion();
        const isTubeDetached = false;
        this.updateMode(isTubeDetached);
        break;
      }
      case APPDATA.ACTIVATE:
        // this.props.dispatch(deviceInfoActions.updateLicenseActivationMode(APPDATA.LICENSE_ACTIVATION_MODE.ONLINE));
        // this._bus.publish(EventLicenseService.LicenseModalService, { licenseMode: APPDATA.LICENSE_ACTIVATION_MODE.ONLINE });
        this.props.dispatch(deviceInfoActions.updateLicenseActivationMode(APPDATA.LICENSE_ACTIVATION_MODE.OFFLINE));
        this._bus.publish(EventLicenseService.LicenseModalService, {
          licenseMode: APPDATA.LICENSE_ACTIVATION_MODE.OFFLINE,
        });
        break;

      case APPDATA.REMOTE_SUPPORT:
        this.remoteSupportModal();
        break;
      default:
        break;
    }
  };

  remoteSupportModal() {
    const popUpButton = [
      {
        id: APPDATA.MESSAGES.REMOTE_SUPPORT.MODAL.BUTTON.AUTHORIZE,
        isPrimaryButton: true,
        onClick: this.onClickRemoteSupportModal,
        label: APPDATA.MESSAGES.REMOTE_SUPPORT.MODAL.BUTTON.AUTHORIZE,
        // disabled: !isTubeDetached,
      },
      {
        id: APPDATA.CANCEL,
        isPrimaryButton: false,
        onClick: this.onClickRemoteSupportModal,
        label: APPDATA.CANCEL,
      },
    ];
    this.props.dispatch(
      modalActions.showPopUp({
        popUpTitle: APPDATA.MESSAGES.REMOTE_SUPPORT.MODAL.TITLE,
        popUpText: (
          <div>
            <div className=" ">{newLineHtml(APPDATA.MESSAGES.REMOTE_SUPPORT.MODAL.TEXT)}</div>
            <div className="row warning-div">
              <div className="icon">
                <span className="glyphicon glyphicon-alert " />
              </div>
              <div className="warning-div-text">{APPDATA.MESSAGES.REMOTE_SUPPORT.MODAL.WARNING}</div>
            </div>
          </div>
        ),
        popUpButton,
      }),
    );
  }

  onClickRemoteSupportModal = (e) => {
    switch (e.currentTarget.id) {
      case APPDATA.MESSAGES.REMOTE_SUPPORT.MODAL.BUTTON.AUTHORIZE:
        this.postStartRemoteSupport();
        break;
      case APPDATA.CANCEL:
        break;
      default:
        break;
    }
    this.props.dispatch(modalActions.hidePopUp());
  };

  postStartRemoteSupport = () => {
    const param = {};
    const passingVariabel = {};
    Post(
      APPDATA.API.API_REMOTE_SUPPORT.POST_START_REMOTE_SUPPORT,
      param,
      this.successPostStartRemoteSupport,
      passingVariabel,
      this.errorPostStartRemoteSupport,
      this.failedPostStartRemoteSupport,
    );
  };

  successPostStartRemoteSupport = (response, passingVariabel) => {
    consoleLog('successPostStartRemoteSupport', {response, passingVariabel});

    this.props.dispatch(
      loadingActions.updateLoading({
        showLoading: true,
        loadingText: APPDATA.MESSAGES.REMOTE_SUPPORT.LOADING.AUTHORIZE,
        loadingClickEvent: undefined,
        loadingButton1: {
          label: APPDATA.CANCEL,
          onClick: () => {
            this.postStopRemoteSupport();
            this.props.dispatch(loadingActions.showLoading(false));
            if (typeof this._remoteSupportSessionPolling !== 'undefined') {
              clearInterval(this._remoteSupportSessionPolling);
              this._remoteSupportSessionPolling = undefined;
            }
            if (typeof this._remoteSupportDeviceStatusPolling !== 'undefined') {
              clearInterval(this._remoteSupportDeviceStatusPolling);
              this._remoteSupportDeviceStatusPolling = undefined;
            }
          },
        },
      }),
    );
    this._remoteSupportSessionPolling = setInterval(() => {
      this.getRemoteSupportSession();
    }, APPDATA.CONFIGURATION.INTERVAL.STATUS_TIME_UPDATE);
  };

  failedPostStartRemoteSupport = (response, passingVariabel) => {
    consoleLog('failedPostStartRemoteSupport', {response, passingVariabel});
    this.props.dispatch(loadingActions.showLoading(false));
    this.props.dispatch(
      setupActions.showAlert({
        alertShow: true,
        alertText: APPDATA.MESSAGES.REMOTE_SUPPORT.ALLERT.NO_INTERNET_CONNECTION, // response.message,
        alertStyle: APPDATA.ENUM.ALERT_TYPE.ALERT_DANGER,
      }),
    );
  };

  errorPostStartRemoteSupport = (error, passingVariabel) => {
    consoleError('errorPostStartRemoteSupport', {error, passingVariabel});
    this.props.dispatch(loadingActions.showLoading(false));
    this.props.dispatch(
      setupActions.showAlert({
        alertShow: true,
        alertText: APPDATA.MESSAGES.REMOTE_SUPPORT.ALLERT.NO_INTERNET_CONNECTION, // response.message,
        alertStyle: APPDATA.ENUM.ALERT_TYPE.ALERT_DANGER,
      }),
    );
  };

  postStopRemoteSupport = () => {
    const param = {};
    const passingVariabel = {};
    Post(
      APPDATA.API.API_REMOTE_SUPPORT.POST_STOP_REMOTE_SUPPORT,
      param,
      this.successPostStopRemoteSupport,
      passingVariabel,
      this.errorPostStopRemoteSupport,
      this.failedPostStopRemoteSupport,
    );
  };

  // eslint-disable-next-line class-methods-use-this
  successPostStopRemoteSupport = (response, passingVariabel) => {
    consoleLog('successPostStopRemoteSupport', {response, passingVariabel});
  };

  // eslint-disable-next-line class-methods-use-this
  failedPostStopRemoteSupport = (response, passingVariabel) => {
    consoleLog('failedPostStopRemoteSupport', {response, passingVariabel});
  };

  // eslint-disable-next-line class-methods-use-this
  errorPostStopRemoteSupport = (error, passingVariabel) => {
    consoleError('errorPostStopRemoteSupport', {error, passingVariabel});
  };

  getRemoteSupportSession = () => {
    const param = {};
    const passingVariable = {};
    Get(
      APPDATA.API.API_REMOTE_SUPPORT.GET_REMOTE_SUPPORT_SESSION,
      param,
      this.successGetRemoteSupportSession,
      passingVariable,
      this.errorGetRemoteSupportSession,
    );
  };

  successGetRemoteSupportSession = (response, passingVariabel) => {
    consoleLog('successGetRemoteSupportSession', {response, passingVariabel});
    // data: {
    //     message: null;
    //     sessionAction: "Start";
    //     sessionState: "InProgress";
    // }
    this.setState(
      {
        remoteSession: response.data,
      },
      () => {
        if (response.data.sessionState === APPDATA.ENUM.REMOTE_SUPPORT.SESSION_STATE.Success) {
          if (typeof this._remoteSupportSessionPolling !== 'undefined') {
            clearInterval(this._remoteSupportSessionPolling);
            this._remoteSupportSessionPolling = undefined;
          }
          this._remoteSupportDeviceStatusPolling = setInterval(() => {
            this.getRemoteSupportDeviceStatus();
          }, APPDATA.CONFIGURATION.INTERVAL.STATUS_TIME_UPDATE);
        } else if (response.data.sessionState === APPDATA.ENUM.REMOTE_SUPPORT.SESSION_STATE.Fail) {
          if (typeof this._remoteSupportSessionPolling !== 'undefined') {
            clearInterval(this._remoteSupportSessionPolling);
            this._remoteSupportSessionPolling = undefined;
          }
          if (typeof this._remoteSupportDeviceStatusPolling !== 'undefined') {
            clearInterval(this._remoteSupportDeviceStatusPolling);
            this._remoteSupportDeviceStatusPolling = undefined;
          }
          this.props.dispatch(loadingActions.showLoading(false));
          this.props.dispatch(
            setupActions.showAlert({
              alertShow: true,
              alertText: APPDATA.MESSAGES.REMOTE_SUPPORT.ALLERT.NO_INTERNET_CONNECTION, // response.message,
              alertStyle: APPDATA.ENUM.ALERT_TYPE.ALERT_DANGER,
            }),
          );
        }
      },
    );
  };

  // eslint-disable-next-line class-methods-use-this
  // failedGetRemoteSupportSession = ( response, passingVariabel) => {
  //   consoleLog('failedGetRemoteSupportSession', {response, passingVariabel});
  // };

  errorGetRemoteSupportSession = (error, passingVariabel) => {
    consoleError('errorGetRemoteSupportSession', {error, passingVariabel});
    this.props.dispatch(loadingActions.showLoading(false));
    this.props.dispatch(
      setupActions.showAlert({
        alertShow: true,
        alertText: APPDATA.MESSAGES.REMOTE_SUPPORT.ALLERT.NO_INTERNET_CONNECTION, // response.message,
        alertStyle: APPDATA.ENUM.ALERT_TYPE.ALERT_DANGER,
      }),
    );
  };

  getRemoteSupportDeviceStatus = () => {
    const param = {};
    const passingVariable = {};
    Get(
      APPDATA.API.API_REMOTE_SUPPORT.GET_REMOTE_SUPPORT_DEVICE_STATUS,
      param,
      this.successGetRemoteSupportDeviceStatus,
      passingVariable,
      this.errorGetRemoteSupportDeviceStatus,
    );
  };

  successGetRemoteSupportDeviceStatus = (response, passingVariabel) => {
    consoleLog('successGetRemoteSupportDeviceStatus', {response, passingVariabel});
    // data: {
    //     id: null;
    //     status: "UnManage";
    // }
    this.setState(
      {
        remoteDeviceStatus: response.data,
      },
      async () => {
        if (
          this.state.remoteSession.sessionState === APPDATA.ENUM.REMOTE_SUPPORT.SESSION_STATE.Success &&
          this.state.remoteDeviceStatus.status === APPDATA.ENUM.REMOTE_SUPPORT.DEVICE_STATUS.Manage
        ) {
          consoleLog('Success Authorize Support', this.state.remoteSession, this.state.remoteDeviceStatus);

          this.props.dispatch(loadingActions.showLoading(false));
          if (typeof this._remoteSupportSessionPolling !== 'undefined') {
            clearInterval(this._remoteSupportSessionPolling);
            this._remoteSupportSessionPolling = undefined;
          }
          if (typeof this._remoteSupportDeviceStatusPolling !== 'undefined') {
            clearInterval(this._remoteSupportDeviceStatusPolling);
            this._remoteSupportDeviceStatusPolling = undefined;
          }

          consoleLog(
            'Success Authorize Support after',
            this.state.remoteSession,
            this.state.remoteDeviceStatus,
            this._remoteSupportDeviceStatusPolling,
            this._remoteSupportSessionPolling,
          );
          window.location.href = APPDATA.REMOTE_SUPPORT_PAGE_ADDRESS;
        }
      },
    );
  };

  // failedGetRemoteSupportDeviceStatus = ( response, passingVariabel) => {
  //   consoleLog('failedGetRemoteSupportDeviceStatus', {response, passingVariabel});
  // };

  // eslint-disable-next-line class-methods-use-this
  errorGetRemoteSupportDeviceStatus = (error, passingVariabel) => {
    consoleError('errorGetRemoteSupportDeviceStatus', {error, passingVariabel});
  };

  // get info
  getInfo = () => {
    const param = {};
    const passingVariable = {};
    Get(APPDATA.API.GET_INFO, param, this.successGetInfo, passingVariable);
  };

  successGetInfo(response) {
    consoleLog('Device info', response, this, this.props);
    // var SoftwareName = response.data[APPDATA.KEY.SoftwareName];
    // SoftwareName = SoftwareName.split(",");
    // SoftwareName = SoftwareName[0];
    const deviceInfo = {
      deviceSerialNumber: response.data[APPDATA.KEY.DeviceSerialNo],
      firmwareName: response.data[APPDATA.KEY.FirmwareName],
      firmwareVersion: response.data[APPDATA.KEY.FirmwareVersion],
      // softwareName: response.data[APPDATA.KEY.SoftwareName],
      softwareVersion: response.data[APPDATA.KEY.SoftwareVersion],
      buildDate: response.data[APPDATA.KEY.BuildDate],
      hostName: response.data[APPDATA.KEY.HostName],
      ipAddress: response.data[APPDATA.KEY.IPAddress],
      macAddress: response.data[APPDATA.KEY.MacAddress],

      licenseStatus: undefined,
      licenseType: undefined,
      licenseModifiedDate: undefined,
      licenseExpiredDate: undefined,
      clientID: undefined,
    };
    console.log('tes', this.props.dispatch);

    this.props.dispatch(deviceInfoActions.updateDeviceInfo(deviceInfo));
  }

  // eslint-disable-next-line class-methods-use-this
  gereateTextInfo(info) {
    const infoText = info.map((info) => (
      <div
        className="row col-md-12 infoText"
        key={info.label}
      >
        <div className="col-md-6">
          <span className="spanStyleTextView no-padding">{info.label}</span>
        </div>
        <div className="col-md-6 no-padding">
          <span className="spanStyleTextView no-padding">{info.value}</span>
        </div>
      </div>
    ));
    return infoText;
  }

  render() {
    const {
      deviceSerialNumber,
      firmwareVersion,
      softwareVersion,
      buildDate,
      hostName,
      ipAddress,
      macAddress,
      licenseStatus,
      licenseType,
      licenseModifiedDate,
      licenseExpiredDate,
      clientID,
    } = this.props;
    // const debuggingAddress = `${window.location.protocol}//${this.props.ipAddress}:${window.location.port}/debug`;
    const infoText = [
      {
        label: APPDATA.INFO_PAGE.DEVICE_SERIAL_NUMBER,
        value: deviceSerialNumber,
      },
      // {
      // 	label: APPDATA.INFO_PAGE.FIRMWARE_NAME,
      // 	value: firmwareName,
      // },
      {
        label: APPDATA.INFO_PAGE.FIRMWARE_VERSION,
        value: firmwareVersion,
      },
      // {
      // 	label: APPDATA.INFO_PAGE.SOFTWARE_NAME,
      // 	value: softwareName,
      // },
      {
        label: APPDATA.INFO_PAGE.SOFTWARE_VERSION,
        value: softwareVersion,
      },
      {
        label: APPDATA.INFO_PAGE.RELEASE_DATE,
        value: buildDate,
      },
      {
        label: APPDATA.INFO_PAGE.HOST_NAME,
        value: hostName,
      },
      {
        label: APPDATA.INFO_PAGE.IP_ADDRESS,
        value: ipAddress,
      },
      {
        label: APPDATA.INFO_PAGE.MAC_ADDRESS,
        value: macAddress,
      },
    ];
    const licenseInfoText = [
      {
        label: APPDATA.INFO_PAGE.LICENSE_STATUS,
        value:
          licenseStatus === undefined || licenseStatus === '' ? '-' : APPDATA.MESSAGES.LICENSE.STATUS[licenseStatus],
      },
      {
        label: APPDATA.INFO_PAGE.LICENSE_TYPE,
        value: licenseType === undefined || licenseType === '' ? '-' : APPDATA.MESSAGES.LICENSE.TYPE[licenseType],
      },
      {
        label: APPDATA.INFO_PAGE.LICENSE_MODIFIED_DATE,
        value:
          licenseModifiedDate === undefined || licenseModifiedDate === '' ? '-' : licenseModifiedDate.split(' ')[0],
      },
      {
        label: APPDATA.INFO_PAGE.LICENSE_EXPIRED_DATE,
        value: licenseExpiredDate === undefined || licenseExpiredDate === '' ? '-' : licenseExpiredDate.split(' ')[0],
      },
      {
        label: APPDATA.INFO_PAGE.CLIENT_ID,
        value: clientID === undefined || clientID === '' ? '-' : clientID,
      },
    ];

    const style = {
      constraint: {
        fontSize: this.props.fontSize - 4,
        // fontSize: "20px",
      },
    };
    const remoteURL = `${APPDATA.CONFIGURATION.APP_ROOT_PROTOCOL}//${ipAddress}:${APPDATA.CONFIGURATION.APP_ROOT_PORT}`;

    return (
      <div
        style={style.constraint}
        className="info-page"
      >
        <div className="row info-detail-row">
          <div className="col-md-9 info-detail">
            <div className="row diviceInfoDiv">
              <div className="col-md-9 no-padding">{this.gereateTextInfo(infoText)}</div>
            </div>

            <div className="row licenseInfoDiv">
              <div className="col-md-9 no-padding">{this.gereateTextInfo(licenseInfoText)}</div>
              <div className="col-md-3 ">
                {/* <br /> */}
                <button
                  type="button"
                  id={APPDATA.ACTIVATE}
                  className="infoButton"
                  onClick={this.onClick}
                >
                  {APPDATA.ACTIVATE}
                </button>
                {/* <UsbSoftwareUpdate/> */}
              </div>
            </div>
          </div>
          <div className="col-md-3">
            <div className="row qr-code-row">
              {ipAddress === DEVICE_NOT_CONNECTED_TO_NETWORK ? (
                <DEVICE_NOT_CONNECTED />
              ) : (
                <QR_CODE_VIEW url={remoteURL} />
              )}
            </div>
          </div>
        </div>
        <div className="contact-row">
          <div className="col-md-2 contactLabel ">
            <span className="spanStyleTextView no-padding">Contact</span>
          </div>
          <div className="col-md-6 no-padding contactInfo">
            {APPDATA.FMLX_CONTACT.split('\n').map((item, index) => (
              // consoleLog("contact", {index, item});
              <div
                className="infoText "
                // eslint-disable-next-line react/no-array-index-key
                key={index}
              >
                <span className="spanStyleTextView no-padding">{item}</span>
              </div>
            ))}
          </div>

          {/* #OP85121 - Hide Remote Support Button due teamviewer account is no longer support for remote support.
          <div className="col-md-4 ">
            <button
              type="button"
              id={APPDATA.REMOTE_SUPPORT}
              className="secondaryButton btn "
              onClick={this.onClick}
            >
              {APPDATA.REMOTE_SUPPORT}
            </button>
          </div> */}
        </div>
      </div>
    );
  }
}
export default InfoPage;

function QR_CODE_VIEW({url}) {
  return (
    <div className={`device-qr-url-row ${gapFixerClass()}`}>
      <QRCode
        value={url}
        size={150}
      />
      <span className="url-style">{url}</span>
    </div>
  );
}
function DEVICE_NOT_CONNECTED() {
  return (
    <div className="device-not-connected-row">
      <span className="not-connected-text">
        <img
          src={NoNetworkIcon}
          alt={NoNetworkIcon}
          className="no-network-logo"
        />
        {`${DEVICE_NOT_CONNECTED_TO_NETWORK}.`}
        Please check the network connection.
      </span>
    </div>
  );
}
